// Signin actions
export const SET_SIGN_IN_LOADING = 'SET_SIGN_IN_LOADING';
export const SET_SIGN_IN_SUCCESS = 'SET_SIGN_IN_SUCCESS';
export const SET_SIGN_IN_ERROR = 'SET_SIGN_IN_ERROR';

export const SET_SIGN_UP_LOADING = 'SET_SIGN_UP_LOADING';
export const SET_SIGN_UP_SUCCESS = 'SET_SIGN_UP_SUCCESS';
export const SET_SIGN_UP_ERROR = 'SET_SIGN_UP_ERROR';
export const SET_SIGN_UP_SUCCESS_LOADING = 'SET_SIGN_UP_SUCCESS_LOADING';

export const SET_SIGN_OUT = 'SET_SIGN_OUT';

// Signup actions
export const SET_POST_BIO_LOADING = 'SET_POST_BIO_LOADING';
export const SET_POST_BIO_SUCCESS = 'SET_POST_BIO_SUCCESS';
export const SET_POST_BIO_ERROR = 'SET_POST_BIO_ERROR';

// Chat actions
export const SET_CHAT_LOADING = 'SET_CHAT_LOADING';
export const SET_CHAT_SUCCESS = 'SET_CHAT_SUCCESS';
export const SET_CHAT_ERROR = 'SET_CHAT_ERROR';

export const SET_CONVO_LOADING = 'SET_CONVO_LOADING';
export const SET_CONVO_SUCCESS = 'SET_CONVO_SUCCESS';
export const SET_CONVO_ERROR = 'SET_CONVO_ERROR';

export const SET_RECENT_CONVO_LOADING = 'SET_RECENT_CONVO_LOADING';
export const SET_RECENT_CONVO_SUCCESS = 'SET_RECENT_CONVO_SUCCESS';
export const SET_RECENT_CONVO_ERROR = 'SET_RECENT_CONVO_ERROR';

// ANALYTICS DASHBOARD
export const ANALYTICS_DASHBOARD_CONTENT_ERROR = 'ANALYTICS_DASHBOARD_CONTENT_ERROR';
export const GET_INITIAL_ANALYTICS_DASHBOARD_CONTENT = 'GET_INITIAL_ANALYTICS_DASHBOARD_CONTENT';
export const GET_MORE_ANALYTICS_DASHBOARD_CONTENT = 'GET_MORE_ANALYTICS_DASHBOARD_CONTENT';
export const GET_PERIODIC_ANALYTICS_DASHBOARD_CONTENT = 'GET_PERIODIC_ANALYTICS_DASHBOARD_CONTENT';
export const SET_INITIAL_ANALYTICS_DASHBOARD_CONTENT = 'SET_INITIAL_ANALYTICS_DASHBOARD_CONTENT';
export const SET_MORE_ANALYTICS_DASHBOARD_CONTENT = 'SET_MORE_ANALYTICS_DASHBOARD_CONTENT';
export const SET_PERIODIC_ANALYTICS_DASHBOARD_CONTENT = 'SET_PERIODIC_ANALYTICS_DASHBOARD_CONTENT';

//PEOPLE CONTACTS
export const LOADING_PEOPLE_CONTACTS = 'LOADING_PEOPLE_CONTACTS';
export const RECEIVE_PEOPLE_CONTACTS = 'RECEIVE_PEOPLE_CONTACTS';
export const RECEIVE_PEOPLE_CONTACTS_ERROR = 'RECEIVE_PEOPLE_CONTACTS_ERROR';

//FTU COMPLETE
export const SET_FTU_COMPLETE_LOADING = 'SET_FTU_COMPLETE_LOADING';
export const SET_FTU_COMPLETE_SUCCESS = 'SET_FTU_COMPLETE_SUCCESS';
export const SET_FTU_COMPLETE_ERROR = 'SET_FTU_COMPLETE_ERROR';

//OVERVIEW DASHBOARD
export const INITIAL_ANALYTICS_DATA_LOADING = 'INITIAL_ANALYTICS_DATA_LOADING';
export const INITIAL_ANALYTICS_DATA_ERROR = 'INITIAL_ANALYTICS_DATA_ERROR';
export const INITIAL_ANALYTICS_DATA_RESPONSE = 'INITIAL_ANALYTICS_DATA_RESPONSE';